import { ReactNode, useCallback, useEffect, useMemo, useState } from "react";
import { Modal } from "../../../Modal";
import { Button, Form, FormInstance, Row } from "antd";
import { ConfigForm } from "./ConfigForm";
import { GeneralConfiguration } from "./GeneralConfiguration";
import { EnterTooltip } from "../../../EnterTooltip";

type LateChargesModalProps = {
  contractId: string;
  isOpen: boolean;
  form: FormInstance;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isFormDisabled: boolean;
  isPaymentPosted: boolean;
  calculate: (toUpdate?: {
    name: string;
    value: any;
    isUpdatedField?: boolean;
  }) => Promise<0 | 1>;
  isHistoryOpened: boolean;
};

export const LateChargesModal = ({
  contractId,
  isOpen,
  form,
  setIsOpen,
  isFormDisabled,
  isPaymentPosted,
  calculate,
  isHistoryOpened,
}: LateChargesModalProps) => {
  const [initialValues, setInitiaValues] = useState<any>(null);

  const closeModal = useCallback(() => {
    form.setFieldsValue(initialValues);

    setInitiaValues(null);

    setIsOpen(false);
  }, [setIsOpen, initialValues, form]);

  const title: ReactNode = useMemo(() => {
    return (
      <Row className="align-center">
        <h5 className="h h5">Late Charge Configuration</h5>
      </Row>
    );
  }, []);

  const closeBtn: ReactNode = useMemo(
    () => (
      <Row className="justify-space-between">
        <EnterTooltip />
        <Button
          type="primary"
          shape="round"
          onClick={closeModal}
          disabled={isFormDisabled}
          loading={isFormDisabled}
        >
          Close
        </Button>
      </Row>
    ),
    [closeModal, isFormDisabled]
  );

  const setInitialFromForm = useCallback(() => {
    const values = form.getFieldsValue();

    setInitiaValues(values);
  }, [form]);

  useEffect(() => {
    isOpen && setInitialFromForm();
  }, [isOpen, setInitialFromForm]);

  const onCalc = useCallback(
    (toUpdate?: { name: string; value: any; isUpdatedField?: boolean }) => {
      calculate(toUpdate).then(() => setInitialFromForm());
    },
    [calculate, setInitialFromForm]
  );

  return (
    <Modal isOpen={isOpen} title={title} footer={closeBtn} width={670}>
      <Row className="px-8 pb-6 pt-8 late-charges-popup">
        <Form
          className="w-100"
          form={form}
          disabled={isFormDisabled || isPaymentPosted}
        >
          <ConfigForm
            form={form}
            calculate={onCalc}
            isHistoryOpened={isHistoryOpened}
          />
        </Form>
        <GeneralConfiguration contractId={contractId} />
      </Row>
    </Modal>
  );
};
